import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton"
import Analisando from "../../assets/images/Analisando.svg"
import styles from "./CadastroEmAnalise.module.css";
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import servLogin from "../../services/login/servLogin"
import { logout } from "../../state/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { formataDataVemString } from "../../infra/utils/DataUtil"
import { Box, CircularProgress, Modal } from "@mui/material"
import { style as modalStyle } from "../../components/Loading/Loading";


const CadastroEmAnalise = () => {
    const navigate = useNavigate();
    const [responsavel, setResponsavel] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const user = useSelector(state => state.user);
    const [diasRestantes, setDiasRestantes] = useState(0);
    const [podeSolicitarNovaAnalise, setPodeSolicitarNovaAnalise] = useState(false);
    const [situacao, setSituacao] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!localStorage.getItem('firstLoadDone')) {
            localStorage.setItem('firstLoadDone', 1);
        } else {
            dispatch(logout());
        }
    }, []);

    useEffect(() => {
        const analise = async () => {
            try {

                setIsLoading(true);

                const data = await servLogin.consultaAnaliseResponsavel(user.codigoUsuario);

                setIsLoading(false);

                data.Content.DataEnvioSolicitacao = formataDataVemString(data.Content.DataEnvioSolicitacao);
                data.Content.DataPrazoAnalise = formataDataVemString(data.Content.DataPrazoAnalise);

                setResponsavel(data.Content);
                setSituacao(data.Content.Situacao);
                setDiasRestantes(data.Content.PrazoRestanteParaAnaliseCadastroResponsavelTecnico)

                if (diasRestantes <= 5) {
                  return setPodeSolicitarNovaAnalise(true);
                } 

                return setPodeSolicitarNovaAnalise(false); 
            } catch (err) {
                setIsLoading(false);
            }
        }
        
        analise();
    }, [podeSolicitarNovaAnalise, diasRestantes, user]);

    const onClickRevisarCadastro = () => {
        navigate("/revisarCadastro");
    }

    let solicitaNovaAnalise = (podeSolicitarNovaAnalise || situacao === 2);

    return (
        <div className={styles.analiseContainer}>
            <h2>Em análise</h2>
            <p>Olá <b>{responsavel && responsavel.Nome}</b>, estamos concluindo a análise do seu cadastro. Assim que estiver pronta enviaremos um e-mail de confirmação para você e também entraremos em contato pelo telefone que estava no seu cadastro.</p>
            <p>Após a solicitação de revisão do cadastro de habilitação, você possui o prazo de <b>{responsavel && responsavel.PrazoAnaliseCadastroRespTec} dias</b> para revisar o seu cadastro e solicitar uma nova análise. Fique atento aos meios de comunicação que você informou aqui (e-mail e telefone).</p>
            <p><strong>Importante: </strong>A data de início do prazo é contada a partir do horário de atendimento comercial.</p>
        
            <div className={styles.analisePrazos}>
                <div className={styles.analiseDatas}>
                    <p>Data de início do prazo</p>
                    <h3>{responsavel && responsavel.DataEnvioSolicitacao}</h3>
                </div>
                <div className={styles.analiseDatas}>
                    <p>Data limite de análise</p>
                    <h3>{responsavel && responsavel.DataPrazoAnalise}</h3>
                </div>
                <div className={styles.analiseDatas}>
                    <p>Dias restantes</p>
                    <h3>{diasRestantes} dias</h3>
                </div>
            </div>

            <div className={styles.analiseBotoes}>
                <BlueHoverButton variant="contained" sx={{background: "#343434"}} onClick={onClickRevisarCadastro} disabled={ situacao === 1 ? true : false }>Editar cadastro</BlueHoverButton>
                {/* <BlueHoverButton variant="contained" sx={{background: "#343434"}} disabled={!solicitaNovaAnalise} >Solicitar nova análise</BlueHoverButton> */}
            </div>

            <div className={styles.analiseFundo}>
                <img src={Analisando} alt="analise" />
            </div>

            <Modal open={isLoading}>
                    <Box style={modalStyle}>
                        <CircularProgress color="inherit" />
                    </Box>
            </Modal>
        </div>
    )
}

export { CadastroEmAnalise }